import { render } from "./Error.vue?vue&type=template&id=1935d68f"
const script = {}

import exportComponent from "E:\\laragon\\www\\proyectos\\laravel\\sandy_laravel_vue\\filtros_frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__